import { render, staticRenderFns } from "./newPage2.vue?vue&type=template&id=4ed10fb3&scoped=true&"
import script from "./newPage2.vue?vue&type=script&lang=js&"
export * from "./newPage2.vue?vue&type=script&lang=js&"
import style0 from "./newPage2.vue?vue&type=style&index=0&id=4ed10fb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed10fb3",
  null
  
)

export default component.exports